import { PeopleTeam24Regular } from '@fluentui/react-icons'
import { Button, Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@opoint/infomedia-storybook'

import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import { ActionBarDropdownMenuItem } from '../../ActionBarDropdownMenuItem'
import { ActionBarActionsProps, ActionVariant } from '../../types'
import { useAlertsRetrieve } from '../../../../../api/alerts/alerts'

const AlertSeeRecipientsAction = ({ variant = ActionVariant.LONG, name }: ActionBarActionsProps) => {
  const dispatch = useAppDispatch()
  const { alertId } = useParams()

  const { data: alertDetail } = useAlertsRetrieve(parseInt(alertId as string, 10))

  const onClickAction = () => {
    if (!alertId || !alertDetail) {
      return
    }

    dispatch({
      type: 'ALERT_RECIPIENT_LIST_OPEN',
      payload: {
        alertId: +alertId,
        alertName: alertDetail?.subject ?? '',
        lastSent: alertDetail?.lastSent,
      },
    })
  }

  if (variant === ActionVariant.MENU) {
    return (
      <ActionBarDropdownMenuItem onClick={onClickAction} data-cy="alertSeeRecipientsBtn">
        <PeopleTeam24Regular />
        {name}
      </ActionBarDropdownMenuItem>
    )
  }

  if (variant === ActionVariant.LONG) {
    return (
      <Button variant="outline" onClick={onClickAction} data-cy="alertSeeRecipientsBtn">
        <PeopleTeam24Regular />
        {name}
      </Button>
    )
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="outline" size="icon" onClick={onClickAction} data-cy="alertSeeRecipientsBtn">
          <PeopleTeam24Regular />
          <span className="sr-only">{name}</span>
        </Button>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent>{name}</TooltipContent>
      </TooltipPortal>
    </Tooltip>
  )
}

export default AlertSeeRecipientsAction
